import type { FC } from 'react'

import { BodyS, FlowPage } from '@monthio/design-system'
import { Switch } from '@monthio/react-components'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useSamsungBrowserWarningModule } from './useSamsungBrowserWarningModule'

const WhiteBackgroundPage = styled(FlowPage)`
	background: #fff;

	& p,
	& div {
		font-size: 14px;
	}

	& p:has(> ul) {
		margin: 0;
		margin-block-start: 8px;
	}

	@media (prefers-color-scheme: dark) {
		& h1,
		& p,
		& li,
		& div {
			color: #a5a5a5;
		}
	}
`

const WhiteText = styled.p`
	color: #fff;
`

const List = styled.ul`
	li + li {
		margin-top: 10px;
	}
`

const ConsentBox = styled.div`
	position: sticky;
	bottom: 0;
`

export const SamsungBrowserWarning: FC = () => {
	const { finish } = useSamsungBrowserWarningModule()

	const onMoveForward = useCallback(() => {
		finish(undefined)
	}, [finish])

	const { t } = useTranslation()

	return (
		<WhiteBackgroundPage>
			<FlowPage.Content $spacing="xs">
				<FlowPage.Header title={t('samsung-browser-warning.header')} />
				<BodyS>{t('samsung-browser-warning.explainer-paragraph')}</BodyS>
				<BodyS>{t('samsung-browser-warning.condition-paragraph')}</BodyS>
				<WhiteText>
					{t('samsung-browser-warning.instruction-paragraph')}
					<List>
						<li>{t('samsung-browser-warning.option-1')}</li>
						<li>{t('samsung-browser-warning.option-2')}</li>
						<li>{t('samsung-browser-warning.option-3')}</li>
					</List>
				</WhiteText>
				<ConsentBox>
					{t('samsung-browser-warning.acknowledge')}
					<Switch onChange={onMoveForward} />
				</ConsentBox>
			</FlowPage.Content>
		</WhiteBackgroundPage>
	)
}
